import React from 'react'

import Button from '../Button'

import classes from './styles'

const Welcome = ({ start }) => (
  <div className={classes.welcomeWrapper}>
    <div className={classes.welcome}>
      <div className={classes.logoWrapper}>
        <img className={classes.logo} src="https://10years.lifehacker.ru/static/images/logo_lh.png" alt=""/>
      </div>

      <div className={classes.content}>

        <div className={classes.texts}>
          <h2 className={classes.title}>
            Ты — издатель!
          </h2>

          <div className={classes.description}>
            Задача минимум — выжить. Задача максимум — подняться выше солнца.
            Перед тобой игра: дана сложная ситуация, в которой оказалось издание. Даны варианты решения, от которых зависит, станет ли издание лучше, останется на прежнем уровне или погибнет. Каждый выбор влияет на следующий шаг.
            Нужно выбирать ответы, которые приведут к успеху: принесут деньги или приведут новых читателей.
            Все ситуации основаны на реальных событиях. Лайфхакер справился, справишься и ты.
          </div>
        </div>

        <div className={classes.footer}>
          <div className={classes.controls}>
            <Button
              onClick={start}
            >
              Играть
            </Button>
          </div>
        </div>
      </div>

    </div>
  </div>
)

Welcome.propTypes = {
  start: React.PropTypes.func.isRequired,
}

export default Welcome


// WEBPACK FOOTER //
// ./src/components/Welcome/Welcome.jsx